/**
 * Read-state placeholder for an overview field that has no value yet. Sits
 * in the value slot of an editable row so the row is a click-to-fill target
 * ("Set Email") rather than a hole in the panel — the row keeps its place,
 * filled or not, and "empty" becomes something to act on.
 *
 * The label is interpolated verbatim: it may be Ahoy vocabulary or a label
 * the customer wrote, and the "Set {label}" wrapper reads correctly either
 * way, so it is never recased here.
 *
 * A field the user can't fill from here (read-only, or no editor for its
 * type) shows the empty-value glyph instead: "Set X" would be a promise the
 * row can't keep.
 *
 * Rendered as a block with its own 20px line so it has the same footprint
 * as a text value (an inline span would take the badge slot's 24px line box
 * and make placeholder rows 2px taller than their filled neighbours).
 */
export function EmptyFieldPlaceholder({
  label,
  isEditable = true,
}: {
  label: string;
  isEditable?: boolean;
}) {
  return (
    <span className='block text-xs md:text-sm leading-5 text-fg-quaternary'>
      {isEditable ? `Set ${label}` : '—'}
    </span>
  );
}
